import React from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { Alert } from '@material-ui/lab';
import { Modal } from "@material-ui/core";
import { useEffect } from "react";
import { store } from './store/store';
import {setHideError} from './actions/errorActions'

function Error() {
    const error: any = useSelector((state: any) => state.err);
    return (<>
        <SimpleModal {...error.error} />
    </>)


}
export default Error

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
    }),
);

export function SimpleModal({ show, title, message }: any) {
    const dispatch = useDispatch()
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);

   

    const handleClose = () => {
     //  dispatch({type:"HIDE ERROR",payload:{}})
     store.dispatch(setHideError({ show: false, title: "", message: "" }))
    };

    const body = (
        <div style={modalStyle} className={classes.paper}>
            <h2 id="simple-modal-title">{title}</h2>
            <p id="simple-modal-description">
                {message}
            </p>
            <SimpleModal />
        </div>
    );

    return (
       <div>

            <Modal
                open={show}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
